import type { DeleteDraftThreads_deleteDraftThreads } from '@ms/yammer-graphql';
import type { Action } from 'redux';

import type { Thread } from '../../state/types';

export const deleteDraftThreadsRequestStatusId = 'intelligent-importer-delete-draft-threads';

export interface DeleteDraftThreadsResponse {
  readonly data: DeleteDraftThreads_deleteDraftThreads;
}

export interface DeleteDraftThreadsPendingAction extends Action {
  readonly type: 'THREADS.DELETE_PENDING';
  readonly payload: {
    readonly threadIds: Thread['id'][];
  };
}

export interface DeleteDraftThreadsFulfilledAction extends Action {
  readonly type: 'THREADS.DELETE_FULFILLED';
  readonly payload: {
    readonly threadIds: Thread['id'][];
  };
}

export interface DeleteDraftThreadsRejectedAction extends Action {
  readonly type: 'THREADS.DELETE_REJECTED';
  readonly payload: {
    readonly threadIds: Thread['id'][];
    readonly error: unknown;
  };
  readonly error: true;
}

export type DeleteDraftThreadsAction =
  | DeleteDraftThreadsPendingAction
  | DeleteDraftThreadsFulfilledAction
  | DeleteDraftThreadsRejectedAction;
